import { render, staticRenderFns } from "./RoutePlanElementShowView.vue?vue&type=template&id=60f4f76c&scoped=true"
import script from "./RoutePlanElementShowView.vue?vue&type=script&lang=js"
export * from "./RoutePlanElementShowView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f4f76c",
  null
  
)

export default component.exports